const ITEMS = ["NOCTURNE DROP", "ÉDITION LIMITÉE", "LIVRAISON 24H EN ÎLE-DE-FRANCE", "2-3 JOURS EN FRANCE", "FABRIQUÉ EN FRANCE", "NO CONFORMITY", "PIÈCES NUMÉROTÉES"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="border-y border-white/10 bg-coal overflow-hidden py-4 select-none">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-syne font-bold uppercase tracking-tight text-lg text-smoke">
                <span className="mx-6">{item}</span>
                <span className="text-blood text-sm">✕</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
